// `v8_trailingSlashAwareDataRequests` stops the server runtime from
// stripping trailing slashes, so it looks the request path up in
// `prerender` as `/es/`. Without the slash it finds no match, falls back
// to SPA mode and writes the HydrateFallback instead of the page.
export function ensureTrailingPathSlash(path: string) {
  return path.endsWith('/') ? path : `${path}/`;
}
